import {
  businessRelationshipService,
  type BusinessRelationshipListParams,
} from '@/entities/business-relationship/api/business-relationship.api';
import { LIST_STALE_TIME } from '@/shared/constants/query';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export const businessRelationshipKeys = {
  all: ['partner-business-relationships'] as const,
  list: (params: BusinessRelationshipListParams) =>
    [...businessRelationshipKeys.all, 'list', params] as const,
};

/** 06 거래처 정보 목록. page는 0부터. */
export const useBusinessRelationshipList = (
  params: BusinessRelationshipListParams,
) =>
  useQuery({
    queryKey: businessRelationshipKeys.list(params),
    queryFn: () => businessRelationshipService.list(params),
    placeholderData: keepPreviousData,
    staleTime: LIST_STALE_TIME,
  });
